import { IOption } from 'src/types/IOption'

export const UnsubscribeDigitOptions: IOption[] = Array(10)
  .fill(0)
  .map((_, index) => index)
  .map((index) => ({ value: index, title: String(index) }))
